module.exports = __webpack_public_path__ + "static/media/fpm3.fad48a9f.png";